<script>
  import { enhance } from "$app/forms";
  import { cart } from "$lib/state/cart";
  import {
    ADD_TO_CART_EVENT,
    DELETE_ITEM_FROM_CART_EVENT,
    REMOVE_FROM_CART_EVENT,
    dispatchCustomEvent,
  } from "$lib/utils/events";
  import { klaviyoDeleteProduct } from "$lib/utils/KlaviyoEvents";
  /**@type {import('magento-gql-types').CartItemInterface}*/
  export let item;
  export let qty = 0;
  export let sku = "";
  export let isMini = false;

  let signalController = new AbortController();
  let fetchInProgress = false;

  //@ts-ignore
  const updateCart = (data) => {
    cart.set(data.cart);
  };

  const removeItem = async () => {
    try {
      const request = await fetch(`/cart?itemId=${item.uid}`, { method: "DELETE" });
      const response = await request.json();
      klaviyoDeleteProduct(item, item.quantity);
      if (request.status === 200) {
        dispatchCustomEvent(DELETE_ITEM_FROM_CART_EVENT, $cart, item.uid);
        updateCart(response);
        return;
      }
      throw new Error(/** @type {any} */ (response));
    } catch (error) {
      console.error(error);
    }
  };
  /**@type {any}*/
  let timeout;
  const decreaseQty = async () => {
    clearTimeout(timeout);
    if (qty === 1) {
      removeItem();
    } else {
      qty--;
      timeout = setTimeout(() => {
        updateProductQty();
      }, 1_000);
    }
  };
  const increaseQty = () => {
    clearTimeout(timeout);
    qty++;
    timeout = setTimeout(() => {
      updateProductQty();
    }, 500);
  };

  const updateProductQty = async () => {
    const formData = new FormData();
    formData.set("itemId", String(item.uid));
    formData.set("qty", String(qty));
    formData.set("sku", sku);

    try {
      const responseStream = await fetch(`/cart?itemId=${item.uid}`, {
        signal: signalController.signal,
        method: "PUT",
        body: formData,
      });
      const response = await responseStream.json();
      if (responseStream.status === 200) {
        dispatchCustomEvent(ADD_TO_CART_EVENT, response.cart, sku, qty);
        updateCart(response);
      }
    } catch (error) {
      if (/** @type {Error} */ (error).name !== "AbortError") {
        console.error(error);
      }
    }
  };
</script>

<div class="container" aria-roledescription={`${sku} cart qty`} class:mini={isMini}>
  <button on:click={decreaseQty} aria-labelledby="decrease" class="left">
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="4" viewBox="0 0 15 3">
      <line x2="15" stroke="#fff" stroke-width="4" />
    </svg>
  </button>
  <div class="qty">
    <form action="/cart?/updateCartQty" method="post">
      <input type="hidden" name="itemId" value={item.uid} />
      <input
        type="text"
        name="qty"
        id={`cart-qty-${sku}`}
        value={qty}
        on:change={updateProductQty}
      />
    </form>
  </div>
  <button on:click={increaseQty} aria-labelledby="increase">
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 15 15">
      <g transform="translate(-7.5 -7.5)">
        <line x2="15" transform="translate(7.5 15)" fill="none" stroke="#fff" stroke-width="3" />
        <line x2="15" transform="translate(15 7.5) rotate(90)" stroke="#fff" stroke-width="3" />
      </g>
    </svg>
  </button>
</div>

<span id="increase" class="label"> Increase item quantity in cart </span>
<span id="decrease" class="label"> Decrease item quantity in cart </span>

<style>
  .container {
    width: fit-content;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(3, 45px);
    align-items: center;
    justify-items: center;
    gap: 5px;
  }
  .container.mini{
    grid-template-columns: repeat(3, 30px);
  }
  button {
    border: none;
    padding: none;
    margin: none;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-color: var(--global);
  }
  .mini > button{
    width: 25px;
    height: 25px;
  }
  .left {
    transform: rotateY(180deg);
  }
  .qty input {
    background: none;
    text-align: center;
    color: var(--global);
    font-size: 2.5rem;
    font-weight: 500;
    max-width: fit-content;
    padding: 0;
    border: none;
    line-height: 1;
    padding-top: 2px;
  }
  .mini .qty input{
    font-size: 2.2rem;
  }

  @media (min-width: 768px) {
    .container {
      grid-template-columns: repeat(3, 60px);
    }
    .qty input {
      font-size: 4rem;
    }
  }
</style>
